import React from "react";

function Navbar() {
  return (
    <>
      <nav className="navbar navbar-dark" style={{ background: "#00000060" }}>
        <div className="container-fluid">
          <span className="navbar-brand mb-0 h1">Forecastify</span>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
